import { ReactNode } from "react";
import ButtonToolbar from "react-bootstrap/ButtonToolbar";
import ActionsMenu from "./ActionsMenu";

type GridToolbarLightProps = {
  items: {
    component: (idx: number, disabled: boolean) => ReactNode;
  }[];
  actions?: {
    label: string;
    onClick: () => void;
  }[];
  disabled?: boolean;
  id: string;
  className: string;
};

const GridToolbarLight = ({
  items = [],
  actions = [],
  disabled = false,
  id,
  className
}: GridToolbarLightProps) => {
  if (!items.length) {
    return null;
  }

  return (
    <ButtonToolbar id={id} className={className}>
      {items.map((item, idx) => item.component(idx, disabled))}
      {actions.length > 0 && (
        <ActionsMenu
          id="toolbar-actions"
          key={items.length}
          actions={actions}
          className="pull-right"
        />
      )}
    </ButtonToolbar>
  );
};

export default GridToolbarLight;
